import { Component, OnInit, ViewChild } from '@angular/core';
import { ApiService } from '../../services/api.service';
import { FrontEndService } from '../../services/front-end.service';
import { DataService } from "../../services/data.service";
import { StateService } from '@uirouter/angular';
import { LogService } from '../../services/log.service';


@Component({
  selector: 'app-verify-coupon',
  templateUrl: './verify-coupon.component.html',
  styleUrls: ['./verify-coupon.component.scss']
})
export class VerifyCouponComponent implements OnInit {
  loading = false;
  couponForm = {};
  transaction = {};
  showicon = false;
  showCouponDetail = false;
  couponIncorrect = true;
  couponMsg = '';
  productArray = [];
  showCamera: boolean = false;

  @ViewChild("infoPanel") infoPanel;

  constructor(
    private apiService: ApiService,
    private frontEndService: FrontEndService,
    private dataService: DataService,
    private stateService: StateService,
    private logService: LogService
  ) { }

  ngOnInit() {
  }

  typeCouponCode(scanner = false) {
    this.couponForm['user_id'] = this.dataService.userDetails['user_id'];
    
    if (!scanner) {
      this.couponForm['coupon_code'] = this.couponForm['coupon_code'].toUpperCase();
    }

    this.loading = true;
    this.apiService.typeCoupon(this.couponForm, (response) => {
      // this.logService.printLog("coupon form -", this.couponForm);
      // this.logService.printLog("Check verify coupon -", response);
      if(response["message"] == "Coupon not found") {
        response['coupon_code'] = this.couponForm['coupon_code'];        
      }
      this.productArray.unshift(response);
      this.loading = false;
      this.showCouponDetail = true;
      this.couponForm['code'] = this.couponForm['coupon_code'];
      this.couponForm['coupon_code'] = '';
      this.infoPanel.getProductData();
      this.infoPanel.isProduct = false;
    });
  }

  codeDetected(event) {
    this.logService.printLog('scan code', event);
    this.couponForm['coupon_code'] = event.toUpperCase();
    this.typeCouponCode();
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/landing_page/src/app/components/verify-coupon/verify-coupon.component.ts